import { assertEx } from '@xyo-network/sdk-xyo-js';
import { parse, stringify } from 'query-string';
import global from '../../global';
class Gtag {
    constructor(ga4id, awid, domains) {
        var _a, _b;
        this.ga4id = ga4id;
        this.awid = awid;
        this.domains = domains;
        global.dataLayer = global.dataLayer || [];
        this.gtag = function () {
            // eslint-disable-next-line prefer-rest-params
            global.dataLayer.push(arguments);
        };
        global.gtag = this.gtag;
        this.gtag('js', new Date());
        this.gtag('config', ga4id);
        //this.gtag('config', awid) - this is configured in the Data Stream in Google Analytics
        const parsedQueryString = parse(document.location.search);
        //we handle the utm_referrer here incase a referrer was forwarded (special.coinapp.co does this)
        sessionStorage.setItem('initialReferrer', decodeURIComponent((_b = (_a = parsedQueryString['utm_referrer']) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : document.referrer));
        delete parsedQueryString['utm_referrer'];
        const remainingSearch = parsedQueryString ? stringify(parsedQueryString) : '';
        sessionStorage.setItem('initialQuery', remainingSearch);
        sessionStorage.setItem('initialPage', document.location.href);
    }
    updatePagePath(page_path) {
        const ga4id = assertEx(this.ga4id, 'Missing GA4ID');
        const pathOnly = page_path.split('?')[0];
        const search = Gtag.getInitialQuery();
        this.gtag('config', ga4id, { page_path: `${pathOnly}${search}` });
    }
    //
    static getInitialQuery() {
        return sessionStorage.getItem('initialQuery') || '';
    }
    static getInitialPage() {
        return sessionStorage.getItem('initialPage') || '';
    }
    static getInitialReferrer() {
        return sessionStorage.getItem('initialReferrer') || '';
    }
    static clearDataLayer() {
        const dataLayer = global.dataLayer;
        dataLayer.length = 0;
    }
    static init(ga4id, awid, domains) {
        if (!this.instance) {
            return this.reinit(ga4id, awid, domains);
        }
        return this.instance;
    }
    static reinit(ga4id, awid, domains) {
        this.instance = new Gtag(ga4id, awid, domains);
        return this.instance;
    }
    static updatePagePath(page_path) {
        const instance = assertEx(this.instance, 'Not initialized');
        return instance.updatePagePath(page_path);
    }
    sendAnalytics(event, data) {
        return new Promise((resolve) => {
            this.gtag('event', event, Object.assign(Object.assign({}, data), { event_callback: () => {
                    resolve();
                }, event_timeout: 2000, page_location: Gtag.getInitialPage(), page_referrer: Gtag.getInitialReferrer(), send_to: this.ga4id }));
        });
    }
    sendAdwords(event, data) {
        return new Promise((resolve) => {
            this.gtag('event', 'conversion', Object.assign(Object.assign({}, data), { event_callback: () => {
                    resolve();
                }, event_timeout: 2000, send_to: `${this.awid}/${event}` }));
        });
    }
}
export default Gtag;
//# sourceMappingURL=Gtag.js.map